import { useTranslation } from 'react-i18next';

import { FlexBox } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { SpinnerIcon } from '@sternum/web/icons';
import { namespaces } from '@sternum/web/services/i18n';

import { LoadingText } from './LoadingState.styles';

export function LoadingState() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  return (
    <FlexBox justifyContent="center" alignItems="center" h="100%">
      <SpinnerIcon color1={Colors.GreyDarkest} color2={Colors.White} />
      <LoadingText>{t('dashboardsLoading')}</LoadingText>
    </FlexBox>
  );
}
